"use client";
// It is a special fix to be able to have all index page files in the same folder

import React, { useEffect } from "react";
import { serviceIsLoading, useServiceHook } from "rylak-common";
import NewFeaturesCard, { RecentFeatureAlertsRow } from "~/app/(pages)/(home)/NewFeaturesCard.js";
import TodoCard from "~/app/(pages)/(home)/TodoCard.js";
import { TurnrGrid } from "~/components/TurnrGrid.jsx";
import { getCurrentDateClient, getSelectedBrandName } from "~/cores/appCore.js";
import { ReturnAppLinkWithCopy } from "~/components/links/ReturnAppLink.jsx";
import { TurnrCard } from "~/components/card/TurnrCard.jsx";
import GenerateReportButton from "~/app/(pages)/(home)/GenerateReportButton.js";
import { fetchMetabaseUrl } from "~/services.js";
import MetabaseDateRangePicker from "~/components/input/selects/MetabaseDateRangePicker.jsx";
import MetabaseIframeCard from "~/components/metabase/MetabaseIframeCard.jsx";
import useMetabaseDates from "~/components/metabase/useMetabaseDates.js";
import { addDays } from "date-fns";

export default function MetaBasePage({ appProps }) {
    // Only the date range is driven by the app; all other dashboard filters are handled by Metabase's own
    // native filter widgets.
    const { selectedDates, selectedDatesAsIsoStrings, originalSelectedDatesAsDates, setDatesSelected, formattedDate } = useMetabaseDates(appProps);

    const { serviceData: metabaseUrlServiceData, fetchServiceData: fetchMetabaseUrlServiceData } = useServiceHook({
        appProps,
        fetchRequested: false,
        fetchFn: fetchMetabaseUrl,
    });

    useEffect(() => {
        if (!serviceIsLoading(appProps?.brandService) && selectedDates) {
            fetchMetabaseUrlServiceData({ date: formattedDate });
        }
    }, [appProps?.brandService, selectedDatesAsIsoStrings]);

    const metabaseUrl = metabaseUrlServiceData?.data?.metabaseUrl;

    return (
        <TurnrGrid container spacing={2}>
            <RecentFeatureAlertsRow appProps={appProps} />
            <TurnrGrid item xs={12} xl={9}>
                <MetabaseIframeCard url={metabaseUrl} serviceData={metabaseUrlServiceData}>
                    <MetabaseDateRangePicker
                        appProps={appProps}
                        maxDate={addDays(getCurrentDateClient(appProps), -1)}
                        value={selectedDates}
                        originalValue={originalSelectedDatesAsDates}
                        onChange={setDatesSelected}
                    />
                </MetabaseIframeCard>
            </TurnrGrid>
            <TurnrGrid item xs={12} xl={3}>
                <TurnrGrid container spacing={2}>
                    <TurnrGrid container item spacing={1}>
                        <TurnrGrid item xs={12}>
                            <TurnrCard>
                                <GenerateReportButton appProps={appProps} fullWidth />
                            </TurnrCard>
                        </TurnrGrid>
                        {getSelectedBrandName(appProps) && (
                            <TurnrGrid item spacing={1} xs={12} alignItems={"center"}>
                                <ReturnAppLinkWithCopy appProps={appProps} fullWidth />
                            </TurnrGrid>
                        )}
                    </TurnrGrid>
                    <TurnrGrid item xs={12}>
                        <TodoCard appProps={appProps} />
                    </TurnrGrid>
                    <TurnrGrid item xs={12}>
                        <NewFeaturesCard appProps={appProps} />
                    </TurnrGrid>
                </TurnrGrid>
            </TurnrGrid>
        </TurnrGrid>
    );
}
